export default function HillRiderIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="12" fill="#4fb3ff" />
      <path d="M0 50C14 34 26 30 40 36s18-6 24-10v38H0z" fill="#8b5a2b" />
      <path d="M0 50C14 34 26 30 40 36s18-6 24-10" stroke="#4caf50" strokeWidth="4" fill="none" />
      <g transform="rotate(-18 30 34)">
        <path d="M14 34h34l2 6H40l-4 4H22l-8-4z" fill="#ffb02e" />
        <path d="M24 34l2-10h6" stroke="#333" strokeWidth="2.5" fill="none" />
        <circle cx="30" cy="25" r="4.5" fill="#ffcf9e" />
        <path d="M25 26a5 5 0 0 1 10 0z" fill="#7b4fd6" />
        <circle cx="20" cy="44" r="6" fill="#1e1e1e" />
        <circle cx="20" cy="44" r="2.5" fill="#c9ced6" />
        <circle cx="42" cy="44" r="6" fill="#1e1e1e" />
        <circle cx="42" cy="44" r="2.5" fill="#c9ced6" />
      </g>
      <rect x="48" y="8" width="10" height="13" rx="2" fill="#e53935" />
      <path d="M51 12l4 5M55 12l-4 5" stroke="#fff" strokeWidth="1.5" />
    </svg>
  );
}
